import CalculationHelper from './CalculationHelper'

import _ from 'lodash'

const DIRECTION = { BACKWARD: 'backward', FORWARD: 'forward' }

const OrderManager = class OrderManager {
  static reorderItem (items, item, position) {
    const orderedItems = _.orderBy(items, 'order')
    const oldPosition = _.findIndex(orderedItems, item)
    const direction = this._getDirection(position, oldPosition)

    const positionOrderValue = this._extractOrderValueForPosition(orderedItems, position)
    const neighboringPositionOrderValue = this._getNeighboringPositionOrderValue(orderedItems, position, direction)

    const order = CalculationHelper.calculateAverage(positionOrderValue, neighboringPositionOrderValue)

    return { ...item, ...{ order } }
  }

  static _getDirection (position, oldPosition) {
    return _.gt(position, oldPosition)
      ? DIRECTION.FORWARD
      : DIRECTION.BACKWARD
  }

  static _getNeighboringPositionOrderValue (items, position, direction) {
    const defaultOderValue = this._calculateDefaultOrderValueByPosition(items, position, 100)
    return _.isEqual(direction, DIRECTION.FORWARD)
      ? this._getNextPositionOrderValue(items, position, defaultOderValue)
      : this._getPreviousPositionOrderValue(items, position, defaultOderValue)
  }

  static _getNextPositionOrderValue (items, position, defaultValue = 0) {
    return this._extractOrderValueForPosition(items, ++position, defaultValue)
  }

  static _getPreviousPositionOrderValue (items, position, defaultValue = 0) {
    return this._extractOrderValueForPosition(items, --position, defaultValue)
  }

  static _extractOrderValueForPosition (items, position, defaultValue = 0) {
    return _.get(items[position], 'order', defaultValue)
  }

  static _calculateDefaultOrderValueByPosition (items, position, offset) {
    const firstPosition = 0
    const lastPosition = items.length - 1

    if (position <= firstPosition) {
      return this._extractOrderValueForPosition(items, firstPosition) - offset
    } else if (position >= lastPosition) {
      return this._extractOrderValueForPosition(items, lastPosition) + offset
    }

    return null
  }
}

export default OrderManager
